<template>
    <u-tit-default v-bind="$attrs" :class="[titClass, titSize]"><slot /></u-tit-default>
</template>

<script>
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";

export default {
    props: {
        titClass: { type: String, default: "" },
        titSize: { type: String, default: "tit--lg" },
    },
    components: {
        UTitDefault,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
